export default function getRedirectUrl(domain: string) {
  const cleanDomain = decodeURIComponent(domain);

  let protocol = 'https';
  if (['localhost:3000'].includes(cleanDomain)) {
    protocol = 'http';
  }
  return `${protocol}://${cleanDomain}`;
}
